export function createAction<T>(actionName: string, staticPayload?: T) {
  return (payload?: T) => ({
    type: actionName,
    payload: typeof staticPayload !== 'undefined' ? staticPayload : payload,
  });
}
